// extracted by mini-css-extract-plugin
module.exports = {"container":"table_container__1iUVh","table":"table_table__1Zg8o","section1":"table_section1__2pXa5","v_subsection1":"table_v_subsection1__3OiV0"};